import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import StatusBadge from "@/components/StatusBadge";
import { Button } from "@/components/ui/button";

export default function HappyCalls() {
  const [list, setList] = useState([]);
  const [tab, setTab] = useState("pending");

  const load = async () => {
    const { data } = await api.get("/complaints");
    setList(data);
  };
  useEffect(() => { load(); }, []);

  // Pending = closed status with no happy_call_result, OR request_to_close
  const pending = list.filter((c) => (c.status === "Request to Close" || c.status === "Closed") && !c.happy_call_result);
  const done = list.filter((c) => c.happy_call_result);

  const rows = tab === "pending" ? pending : done;

  return (
    <div className="space-y-5" data-testid="happy-calls-page">
      <div>
        <h1 className="font-heading text-3xl font-bold text-slate-900">Happy Calls</h1>
        <p className="text-sm text-slate-500 mt-1">CCR follow-up for service quality verification and CSAT capture.</p>
      </div>

      <div className="flex gap-2">
        <Button variant={tab === "pending" ? "default" : "outline"} onClick={() => setTab("pending")} data-testid="hc-tab-pending" className={tab==="pending"?"bg-slate-900 text-white":""}>
          Pending ({pending.length})
        </Button>
        <Button variant={tab === "done" ? "default" : "outline"} onClick={() => setTab("done")} data-testid="hc-tab-done" className={tab==="done"?"bg-slate-900 text-white":""}>
          Completed ({done.length})
        </Button>
      </div>

      <Card><CardContent className="p-0">
        <table className="w-full dense-table">
          <thead className="bg-slate-50 border-b"><tr>
            <th className="text-left text-xs uppercase tracking-wide text-slate-600 font-semibold">Complaint #</th>
            <th className="text-left text-xs uppercase tracking-wide text-slate-600 font-semibold">Customer</th>
            <th className="text-left text-xs uppercase tracking-wide text-slate-600 font-semibold">Brand / Product</th>
            <th className="text-left text-xs uppercase tracking-wide text-slate-600 font-semibold">Status</th>
            <th className="text-left text-xs uppercase tracking-wide text-slate-600 font-semibold">Result</th>
            <th className="text-right text-xs uppercase tracking-wide text-slate-600 font-semibold">CSAT</th>
            <th className="text-right text-xs uppercase tracking-wide text-slate-600 font-semibold"></th>
          </tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={7} className="text-center py-12 text-slate-400">No items.</td></tr>}
            {rows.map((c) => (
              <tr key={c.id} data-testid={`hc-row-${c.complaint_number}`}>
                <td className="font-mono">{c.complaint_number}</td>
                <td>{c.customer_name}<div className="text-xs text-slate-500">{c.phone_number_1}</div></td>
                <td>{c.brand}<div className="text-xs text-slate-500">{c.product_name}</div></td>
                <td><StatusBadge status={c.status} /></td>
                <td className="text-slate-700">{c.happy_call_result || <span className="text-slate-400">—</span>}</td>
                <td className="text-right font-mono">{c.csat_rating ? `${c.csat_rating} ★` : "—"}</td>
                <td className="text-right"><Link to={`/complaints/${c.id}`}><Button variant="outline" size="sm">Open</Button></Link></td>
              </tr>
            ))}
          </tbody>
        </table>
      </CardContent></Card>
    </div>
  );
}
